import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import type { Campaign } from "@/entities/campaign";
import yandexDirectLogo from "@/shared/assets/yandex-direct.svg";

export interface CampaignHeaderProps {
  campaign: Campaign;
}

export const CampaignHeader = ({ campaign }: CampaignHeaderProps) => {
  // Конкретный целевой адрес возврата:
  // Если кампания принадлежит клиенту агентства -> /:client_login
  // Если у пользователя прямой аккаунт -> /
  const backUrl = campaign.client_login ? `/${campaign.client_login}` : "/";
  const backLabel = campaign.client_login ? "Все кампании клиента" : "Все кампании";

  return (
    <div className="flex flex-col gap-3">
      {/* Кнопка «Назад ко всем кампаниям» с прямым переходом без зацикливания истории */}
      <div>
        <Link
          to={backUrl}
          className="inline-flex items-center gap-1.5 text-xs font-medium text-neutral-400 hover:text-neutral-200 transition-colors"
        >
          <ArrowLeft className="w-4 h-4" />
          <span>{backLabel}</span>
        </Link>
      </div>

      {/* Заголовок кампании без обёртки в карточку */}
      <div className="flex flex-row items-center gap-4">
        <img
          src={yandexDirectLogo}
          alt="Яндекс Директ"
          className="w-10 h-10 object-contain shrink-0"
        />
        <div className="min-w-0">
          <h1 className="text-lg font-semibold truncate leading-snug">
            {campaign.name}
          </h1>
          <p className="text-xs text-neutral-400">
            {campaign.type} • {campaign.placement}
          </p>
        </div>
      </div>
    </div>
  );
};
